import { useCallback, useRef } from 'react'
import useWindowResize from './useWindowResize'

const useWindowWidthResize = (callback) => {
  const localsRef = useRef({ width: 0 })
  const onResize = useCallback((event) => {
    if (localsRef.current.width !== window.innerWidth) {
      localsRef.current.width = window.innerWidth
      callback(event)
    }
  }, [callback])
  useWindowResize(onResize)
}

export default useWindowWidthResize
